"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COLUMN_WIDTH = void 0;
Object.defineProperty(exports, "Card", {
  enumerable: true,
  get: function get() {
    return _Card["default"];
  }
});
exports["default"] = exports.ROW_HEIGHT = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _mapValues = _interopRequireDefault(require("lodash/mapValues"));
var _HorizontalList = _interopRequireDefault(require("../HorizontalList"));
var _animations = require("../../hooks/animations");
var _Card = _interopRequireDefault(require("./Card"));
var _excluded = ["data", "groups", "enableCollapsed"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CONTAINER_HEIGHT = 165;
var ROW_HEIGHT = exports.ROW_HEIGHT = 160;
var COLUMN_WIDTH = exports.COLUMN_WIDTH = 400;
var _default = exports["default"] = function _default(_ref) {
  var data = _ref.data,
    groups = _ref.groups,
    enableCollapsed = _ref.enableCollapsed,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var ref = (0, _react.useRef)(null);
  var groupMap = (0, _react.useMemo)(function () {
    return groups.reduce(function (prev, curr) {
      return _objectSpread(_objectSpread({}, prev), {}, (0, _defineProperty2["default"])({}, curr, false));
    }, {});
  }, [groups]);
  var _useState = (0, _react.useState)((0, _mapValues["default"])(groupMap, function () {
      return enableCollapsed ? true : false;
    })),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var series = (0, _react.useMemo)(function () {
    var series = [];
    groups.forEach(function (key) {
      if (data[key] instanceof Array) {
        var length = data[key].length;
        if (length > 1 && collapsed[key]) {
          series.push(data[key][0]);
        } else {
          series.push.apply(series, (0, _toConsumableArray2["default"])(data[key]));
        }
      }
    });
    return series;
  }, [data, groups, collapsed]);
  var _useVirtualizedList = (0, _animations.useVirtualizedList)(series, ['type', 'id']),
    newSeries = _useVirtualizedList.data,
    removedIndexes = _useVirtualizedList.removedIndexes;

  // Reset collapsed state effect
  (0, _react.useEffect)(function () {
    var _iterator = _createForOfIteratorHelper(groups),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!(data[key] instanceof Array) || data[key].length === 1 && collapsed[key]) {
          setCollapsed(function (state) {
            return _objectSpread(_objectSpread({}, state), {}, (0, _defineProperty2["default"])({}, key, false));
          });
        }
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, [data, groupMap]);
  var getColumnWidth = (0, _react.useCallback)(function (_ref2) {
    var index = _ref2.index;
    if (removedIndexes.includes(index)) return 0;
    var base = COLUMN_WIDTH;
    if (collapsed[newSeries[index].type]) {
      base += 20;
    }
    return base;
  }, [newSeries, collapsed, removedIndexes]);
  (0, _react.useEffect)(function () {
    if (ref.current) {
      ref.current.recompute();
    }
  }, [getColumnWidth]);
  return /*#__PURE__*/_react["default"].createElement(_HorizontalList["default"], (0, _extends2["default"])({}, props, {
    ref: ref,
    count: newSeries.length,
    rowHeight: ROW_HEIGHT,
    className: "card-list",
    height: CONTAINER_HEIGHT,
    columnWidth: getColumnWidth,
    cellRenderer: function cellRenderer(cellRenderProps) {
      return props.cellRenderer(_objectSpread(_objectSpread({}, cellRenderProps), {}, {
        listRef: ref.current && ref.current.container,
        data: newSeries[cellRenderProps.columnIndex],
        getStackedCount: function getStackedCount(key) {
          if (collapsed[key]) {
            return data[key].length - 1;
          } else return 0;
        }
      }));
    }
  }));
};
//# sourceMappingURL=index.js.map